import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { LogService } from '../services/log/log.service';
import { AppConstants } from '../constants/appConstants';
import { HttpService } from '../services/http/http.service';
import { config } from '../config';
import { UiService } from '../services/uiloader/uiloader.service';
import { ToasterService } from '../services/toaster/toaster.service';
import { CommonService } from '../services/common/common.service';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import * as libphonenumber from 'google-libphonenumber';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ClientDataService } from '../services/client-data/client-data.service';


@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.sass']
})
export class AdduserComponent implements OnInit {
  selectedItem:string = '';
  selectedClient: string | null = null;
  isDisplayFieldsRequired:boolean = false;
  companyDetails: any = null;
  genderOptions:any = AppConstants.genderOptions;
  isDisabled = true;
  selectedState:any = '';
  userAddressData:any = [];
  selectData:any = [];
  selectedCountry:any= "US";
  phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  isSuperAdmin: boolean = false;
  companies: any[] = [];
  clients: any[] = [];
  filteredClients: any[] = [];
  selectedCompany: any = null;
  clientSearchTerm: string = '';
  userNamesData:any = [
    {
      key: 'firstname',
      value: '',
      placeholder: 'First Name'
    },
    {
      key: 'lastname',
      value: '',
      placeholder: 'Last Name'
    }
  ];

  addUser:any = {
    name: '',
    dateValue: '',
    email: '',
    gender: '',
    mobilephone: ''
  };
  registerForm:any;
  submitted = false;
  maxBirthDate:any;
  minStartDate:any;

  constructor(private location: Location,
    private httpService: HttpService,
    private loader: UiService,
    private logService: LogService,
    private toasterService: ToasterService,
    private common: CommonService,
    private formBuilder: FormBuilder,private route: ActivatedRoute, private router: Router, private authService: AuthService, private clientDataService: ClientDataService) {
      const dt = new Date();
      dt.setFullYear(dt.getFullYear() - 11);
      this.maxBirthDate = dt;
  
      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 100);
      this.minStartDate = minDate;
     }

  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
      this.selectedClient = params['selectedClient'] || null;
    });
    
    this.isSuperAdmin = config.ADMIN_USER_ROLE === this.authService.getUserRole();
    
    // Subscribe to company details
    this.authService.onCompanyDetails.subscribe(details => {
      this.companyDetails = details;
      if (!this.isSuperAdmin) {
        this.checkTrialLimits();
      }
    });
    
    this.getStates();
    this.setUserAddress({});
    
    const companyValidators = this.isSuperAdmin ? [Validators.required] : [];
    const consultantValidators = this.isSuperAdmin ? [Validators.required] : [];
    
    this.registerForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      gender: new FormControl(null, [Validators.required]),
      firstname: new FormControl(null, [Validators.required]),
      lastname: new FormControl(null, [Validators.required]),
      birthdate: new FormControl('', [Validators.required]),
      mobilephone: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required]),
      aptsuite: new FormControl(null, []),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      postalcode: new FormControl(null, [Validators.required]),
      user_id: new FormControl(""),
      company: new FormControl(null, companyValidators),
      consultant: new FormControl(null, consultantValidators),
    });
    
    if (this.isSuperAdmin) {
      this.getCompanies();
    }
  }

  validatephoneNumber() {
    if(!this.registerForm.value.mobilephone || !this.selectedCountry) {
      this.registerForm.get('mobilephone').setErrors({message:"Mobile Number and Country required"});
      return;
    }
    const pNumber = this.phoneUtil.parseAndKeepRawInput( '' + this.registerForm.value.mobilephone.toString() + '', this.selectedCountry);
    const isValidNumber = this.phoneUtil.isValidNumber(pNumber);
    if(!isValidNumber){
      this.registerForm.get('mobilephone').setErrors({message:"Mobile Number is invalid"});
    }
  }

  dateChangeHandler(date: Date){
    this.registerForm.get('birthdate')?.setValue(date);
  }

  selectCountry(ev:any) {
    this.selectedCountry = ev;
  }

  setUserAddress(data:any) {
    this.userAddressData = [
      {
        key: 'address',
        value: data.address,
        placeholder: 'Address'
      },
      {
        key: 'aptsuite',
        value: data.aptsuite,
        placeholder: 'Apt Suite'
      },
      {
        key: 'city',
        value: data.city,
        placeholder: 'City'
      },
      {
        key: 'state',
        value: data.state,
        placeholder: 'State',
        elementType: 'select'
      },
      {
        key: 'postalcode',
        value: data.postalcode,
        placeholder: 'Postal Code'
      },
    ];
    return true;
  }

  getStates() {
    this.httpService.getCall(`${config.apiUrl}/getstates`).subscribe(data => {
      this.selectData = data;
    },
    err => {
        this.logService.logError(err);
    });
  }

  getCompanies() {
    this.loader.showSpinner();
    this.httpService.getCall(`${config.apiUrl}/companyadmin/getcompanies`).subscribe(data => {
      this.companies = data;
      this.loader.stopSpinner();
      this.setDefaultCompanyAndLoadConsultants();
    },
    err => {
      this.logService.logError(err);
      this.loader.stopSpinner();
      this.toasterService.show('error', 'Error', 'Failed to load companies');
    });
  }

  setDefaultCompanyAndLoadConsultants() {
    if (this.companies && this.companies.length > 0) {
      const defaultCompany = this.companies.find((c: any) => c.id == 1) || this.companies[0];
      this.selectedCompany = defaultCompany;
      this.registerForm.get('company')?.setValue(defaultCompany);
      this.getClientsForCompany(defaultCompany.id);
    }
  }

  onCompanySelect(company: any) {
    this.selectedCompany = company;
    this.registerForm.get('company')?.setValue(company);
    this.registerForm.get('consultant')?.reset();
    this.selectedClient = null;
    if (company && company.id) {
      this.getClientsForCompany(company.id);
    }
  }

  getClientsForCompany(companyId: string) {
    this.loader.showSpinner();
    const params = {
      fromIndex: 0,
      limit: 50,
      orderBy: 'DESC',
      orderByOn: 'id',
      searchtext: '',
      companyId: companyId,
      company_id:companyId

    };
    
    this.httpService.postCall(`${config.apiUrl}/companyadmin/getconsultants`, params).subscribe(data => {
      this.clients = data.rows || [];
      this.filteredClients = [...this.clients];
      this.loader.stopSpinner();
    },
    err => {
      this.logService.logError(err);
      this.loader.stopSpinner();
      this.toasterService.show('error', 'Error', 'Failed to load consultants');
    });
  }

  onClientSearch(searchTerm: string) {
    this.clientSearchTerm = searchTerm.toLowerCase();
    this.filteredClients = this.clients.filter(client => {
      return (client.firstname && client.firstname.toLowerCase().includes(this.clientSearchTerm)) ||
             (client.lastname && client.lastname.toLowerCase().includes(this.clientSearchTerm)) ||
             (client.email && client.email.toLowerCase().includes(this.clientSearchTerm));
    });
  }

  onClientSelect(client: any) {
    this.selectedClient = client.id;
    this.registerForm.get('consultant')?.setValue(client);
    this.clientSearchTerm = '';
    this.filteredClients = [...this.clients];
  }

  getUserGender(gender: string) {
    if (gender === 'm') {
      return 'Male';
    } else if ( gender === 'f') {
      return 'Female';
    }
    return '';
  }

  onItemSelect(eve: any, val: string) {
    if (eve.keyCode === 32 || eve.keyCode === 13) {
      this.selectedItem = val;
      if (this.userAddressData[4].key === "postalcode") {
        let pinCode = this.userAddressData[4].value;
        if (pinCode && pinCode.length > 2) {
          this.loader.showSpinner();
          const url = `${config.apiUrl}/getzipcodeaddress`;
          this.httpService.postCall(url, { zip: parseInt(pinCode) }).subscribe(data => {
            let state = this.selectData.find((state: any) => state.stateCode == data[0].state_id);
            if (!state) this.selectData.push({ stateCode: data[0].state_id, stateName: data[0].state_name });
            this.userAddressData[2].value = data[0].city;
            this.userAddressData[3].value = data[0].state_id;
            this.userAddressData[4].value = data[0].zip;
            this.loader.stopSpinner();
          }, err => {
            this.loader.stopSpinner();
          })
        }
      }
    }

  }

  formatNum(val:any) {
    return parseInt(val) < 10 ? `0${val}` : val;
  }

  getDateFormat(date:any) {
    return `${this.formatNum(date.getMonth() + 1)}/${this.formatNum(date.getDate())}/${date.getFullYear()}`;
  }

  saveUserDetails(userId:number) {
    this.registerForm.get('birthdate').setValue(this.getDateFormat(this.registerForm.value.birthdate));
    this.registerForm.get('user_id').setValue(userId);
    console.log(this.registerForm.value);
    const url = `${config.apiUrl}/updateclient`;
    this.httpService.putCall(url, this.registerForm.value).subscribe(data => {
      this.toasterService.show('success', 'Success', 'User Created succesfully');
      
      // Clear cached client data since we've added a new client
      this.clientDataService.clearData();
      
      this.onGoBack();
      this.loader.stopSpinner();
    }, err => {
      this.loader.stopSpinner();
    })
  }

  checkTrialLimits() {
    if (!this.companyDetails || !this.companyDetails.is_trial || !this.selectedClient) {
      return;
    }
    
    // Check if trial has expired
    if (this.clientDataService.isTrialExpired(this.companyDetails)) {
      this.toasterService.show('error', 'Trial Expired', 
        'Your trial period has ended. Please upgrade your plan to continue adding clients.');
      this.router.navigate(['/billing']);
      return;
    }
    
    // Check if trial is still active
    if (!this.clientDataService.isTrialActive(this.companyDetails)) {
      this.toasterService.show('warning', 'Trial Not Active', 
        'Your trial is not currently active. Please contact support or upgrade your plan.');
      this.router.navigate(['/billing']);
      return;
    }
    
    // Use the shared client data service to get current count
    this.clientDataService.getClientCount(this.selectedClient).subscribe(
      currentCount => {
        if (currentCount >= this.companyDetails.trial_client_limit) {
          this.toasterService.show('warning', 'Trial Limit Reached', 
            `You have reached your trial limit of ${this.companyDetails.trial_client_limit} clients. Please upgrade your plan to add more clients.`);
          this.router.navigate(['/billing']);
        }
      },
      err => {
        console.error('Error checking trial limits:', err);
      }
    );
  }

  onSubmit(e:any) {
    e.preventDefault();
    
    // Check trial limits before proceeding
    if (this.companyDetails && this.companyDetails.is_trial) {
      this.checkTrialLimits();
      return false;
    }
    
    this.validatephoneNumber();
    this.isDisplayFieldsRequired = false;
    if (this.registerForm.status === 'INVALID') {
      this.isDisplayFieldsRequired = true;
      return false;
    }
    else{
    this.loader.showSpinner();
    const req: any = {
      email: this.registerForm.value.email,
    };
    
    if (this.isSuperAdmin) {
      const company = this.registerForm.get('company')?.value;
      const consultant = this.registerForm.get('consultant')?.value;
      if (company && consultant) {
        req.companyId = company.id;
        req.consultantId = consultant.id;
      }
    } else {
      req.company_id = this.selectedClient;
      req.companyId = this.selectedClient;
    }
    
    const url = `${config.apiUrl}/createclient`;
    this.httpService.postCall(url, req).subscribe(data=>{
      const { success } = data;
      const split = success.split(':');
      let user_id = 0;
      if (split.length === 2) {
        user_id = parseInt(split[1]);
      }
      this.saveUserDetails(user_id);
    }, err => {
      const msg = this.common.getFormattedError(err);
      this.toasterService.show('error', 'Error Occurred', msg);
      this.loader.stopSpinner();
    });
    return true;
  }
  }

  onGoBack() {
    this.location.back();
  }
}
